import { BOUTIQUE_RECORDS } from "@/generated/boutique_registry.generated";

// Material density is paired with scene brightness; color comes from the photograph.
export const NATURE_THEMES = [
  { id: "rainforest", code: "PLT", name: "Rainforest", detail: "Plantation · Green", opacity: .81, dockOpacity: .66 },
  { id: "ocean", code: "FLL", name: "Clear ocean", detail: "Fort Lauderdale · Blue", opacity: .84, dockOpacity: .72 },
  { id: "sunset", code: "WYN", name: "Rose sunset", detail: "Wynwood · Pink", opacity: .82, dockOpacity: .68 },
  { id: "autumn", code: "CC", name: "Autumn canopy", detail: "Cherry Creek · Red", opacity: .82, dockOpacity: .68 },
  { id: "canyon", code: "PNC", name: "Sandstone light", detail: "Pinecrest · Orange", opacity: .83, dockOpacity: .70 },
  { id: "meadow", code: "RNO", name: "Golden meadow", detail: "RiNo · Yellow", opacity: .85, dockOpacity: .73 },
].map(theme => ({ ...theme, image: `/backgrounds/toto-${theme.id}-v1.jpg` }));

export function boutiqueNatureTheme(user) {
  const identities = [user?.boutique_code, user?.boutique_id, user?.boutique_name, user?.boutique].filter(value => typeof value === "string").map(value => value.trim().toLowerCase());
  const boutique = BOUTIQUE_RECORDS.find(record => [record.code, record.id, record.name, record.shortName].some(value => identities.includes(value.toLowerCase())));
  return NATURE_THEMES.find(theme => theme.code === boutique?.code) || null;
}

export function selectedNatureTheme(selection, user) {
  return selection === "boutique" ? boutiqueNatureTheme(user) : NATURE_THEMES.find(theme => theme.id === selection) || null;
}
